import { Navigate, Outlet } from "react-router-dom";
import { LoginRoute } from "../utils/Constant";

const PrivateRoute = () => {
  const login = localStorage.getItem("adminToken") ?? false;
  return login !== false ? <Outlet /> : <Navigate to={`/${LoginRoute}`} />;
};

export default PrivateRoute;
